export default "/view/img/cee03bc25081875fbb08cef98fcecfbd.jpg";